module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("个人信息")]), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "field"
  }, _vm._l((_vm.resume.profile), function(value, key) {
    return _c('div', {
      staticClass: "control",
      attrs: {
        "label": _vm.titles[key]
      }
    }, [_c('input', {
      staticClass: "input text",
      attrs: {
        "type": "text",
        "placeholder": "input"
      },
      domProps: {
        "value": value
      },
      on: {
        "input": function($event) {
          return _vm.changeResumeField('profile', key, $event.target.value)
        }
      }
    })])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-552d6372","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProfileEditor.vue
// module id = 194
// module chunks = 1